import $ from 'jquery'
import List from 'list.js'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import SwipeListener from 'swipe-listener';
import "slick-carousel";

let options = {
    valueNames: [{ data: ['ID'] }, { attr: 'src', name: 'ImageURL' }, 'CityState', { data: ['Region'] }, { data: ['Amenities'] }, { data: ['Styles'] }, { data: ['YardAttributes'] }, { data: ['DesignPackage'] }, { data: ['Ranking'] }, { attr: 'href', name: 'BlogPostURL'} ],
    item: '<li class="ID Region Amenities Styles YardAttributes DesignPackage Ranking gallery__item"><div class="gallery__item-image"><img class="ImageURL" loading="lazy" alt=""/></div><div class="gallery__item-meta"><h2 class="CityState heading--md"></h2><a class="BlogPostURL button button--text">View Project</a></div></li>',
    page: 7,
    pagination: {
        innerWindow: 3,
        left: 1,
        right: 1,
    }
};

let activeRegionFilters = []
let activeElementFilters = []
let activeConstraintFilters = []
let activeStyleFilters = []
let activeTypeFilters = []

const slickSettings = {
    arrows: false,
    centerMode: true,
    centerPadding: "20px",
};

let valueString = $('#gallery-array').html()

let projects = new List('gallery-main', options, JSON.parse(valueString));
projects.sort('CityState', {
    order: 'asc'
})
projects.sort('Ranking', {
    order: 'asc'
})
projects.items.forEach((item) => {
    item.regionmatch = true;
    item.constraintmatch = true;
    item.elementmatch = true;
    item.stylematch = true;
    item.typematch = true;
})

let cta = $('.js-gallery-cta').html();
$(cta).insertAfter($('.list li:nth-child(3)'));

$('.CityState').each(function (index) {
    let el = $(this);
    el.attr('id', 'project-'+index);
});

$('.BlogPostURL').each(function (index) {
    let el = $(this);
    el.attr('aria-describedby', 'project-' + index);
    if ( !el.attr('href') ) {
        el.remove();
    }
});

$('.js-region-filter').change(function () {
    let regionIsChecked = this.checked;
    let regionValue = $(this).val();
    if (regionIsChecked) {
        activeRegionFilters.push(regionValue);
    }
    else {
        activeRegionFilters.splice(activeRegionFilters.indexOf(regionValue), 1);
    }
    projects.items.forEach((item) => {
        if (activeRegionFilters.length > 0) {
            if (activeRegionFilters.indexOf(item.values().Region) > -1) {
                item.regionmatch = true;
            } else {
                item.regionmatch = false;
            }
        } else {
            item.regionmatch = true;
        }
    })
});

$('.js-constraint-filter').change(function () {
    let constraintIsChecked = this.checked;
    let constraintValue = $(this).val();
    if (constraintIsChecked) {
        activeConstraintFilters.push(constraintValue);
    }
    else {
        activeConstraintFilters.splice(activeConstraintFilters.indexOf(constraintValue), 1);
    }
    projects.items.forEach((item) => {
        if (activeConstraintFilters.length > 0) {
            let constraints = item.values().YardAttributes
            let hasConstraint = false;
            constraints.forEach(function (constraints) {
                if (activeConstraintFilters.indexOf(constraints) > -1) {
                    hasConstraint = true;
                }
            });
            if (hasConstraint == true) {
                item.constraintmatch = true;
            } else {
                item.constraintmatch = false;
            }
        } else {
            item.constraintmatch = true;
        }
    })
});

$('.js-element-filter').change(function () {
    let elementIsChecked = this.checked;
    let elementValue = $(this).val();
    if (elementIsChecked) {
        activeElementFilters.push(elementValue);
    }
    else {
        activeElementFilters.splice(activeElementFilters.indexOf(elementValue), 1);
    }
    projects.items.forEach((item) => {
        if (activeElementFilters.length > 0) {
            let elements = item.values().Amenities
            let hasElement = false;
            elements.forEach(function (elements) {
                if (activeElementFilters.indexOf(elements) > -1) {
                    hasElement = true;
                }
            });
            if (hasElement == true) {
                item.elementmatch = true;
            } else {
                item.elementmatch = false;
            }
        } else {
            item.elementmatch = true;
        }
    })
});

$('.js-style-filter').change(function () {
    let styleIsChecked = this.checked;
    let styleValue = $(this).val();
    if (styleIsChecked) {
        activeStyleFilters.push(styleValue);
    }
    else {
        activeStyleFilters.splice(activeStyleFilters.indexOf(styleValue), 1);
    }
    projects.items.forEach((item) => {
        if (activeStyleFilters.length > 0) {
            let styles = item.values().Styles
            let hasStyle = false;
            styles.forEach(function (styles) {
                if (activeStyleFilters.indexOf(styles) > -1) {
                    hasStyle = true;
                }
            });
            if (hasStyle == true) {
                item.stylematch = true;
            } else {
                item.stylematch = false;
            }
        } else {
            item.stylematch = true;
        }
    })
});

$('.js-type-filter').change(function () {
    let typeIsChecked = this.checked;
    let typeValue = $(this).val();
    if (typeIsChecked) {
        activeTypeFilters.push(typeValue);
    }
    else {
        activeTypeFilters.splice(activeTypeFilters.indexOf(typeValue), 1);
    }
    projects.items.forEach((item) => {
        if (activeTypeFilters.length > 0) {
            if (activeTypeFilters.indexOf(item.values().DesignPackage) > -1) {
                item.typematch = true;
            } else {
                item.typematch = false;
            }
        } else {
            item.typematch = true;
        }
    })
});

$('.js-filter').change(function () {
    projects.filter(function (item) {
        if ((item.regionmatch == true) && (item.constraintmatch == true) && (item.elementmatch == true) && (item.stylematch == true) && (item.typematch == true) ) {
            return true;
        } else {
            return false;
        }
    });
});

projects.on('updated', function (list) {
    let isFirst = list.i == 1;
    let isLast = list.i > list.matchingItems.length - list.page;

    $('.js-page-prev, .js-page-next').prop('disabled', false);

    let numOnPage = $('.list li').length;
    if (numOnPage > 2) {
        $(cta).insertAfter($('.list li:nth-child(3)'));
    }

    $('.CityState').each(function (index) {
        let el = $(this);
        el.attr('id', 'project-' + index);
    });

    $('.BlogPostURL').each(function (index) {
        let el = $(this);
        el.attr('aria-describedby', 'project-' + index);
        if (!el.attr('href')) {
            el.remove();
        }
    });

    if (isFirst) {
        $('.js-page-prev').prop('disabled', true);
    }
    if (isLast) {
        $('.js-page-next').prop('disabled', true);
    }

    if (list.matchingItems.length <= 7) {
        $('.gallery__pagination').hide();
    } else {
        $('.gallery__pagination').show();
    }

    if (list.matchingItems.length > 0) {
        $('.no-results').hide()
    } else {
        $('.no-results').show()
    }

    document.querySelector('.gallery').scrollIntoView({
        behavior: 'smooth'
    });

    $("ul.list").removeClass("slick-initialized");
    $("ul.list").removeClass("slick-slider");
    if ($(window).width() < 700) {
        $("ul.list").slick(slickSettings);
    }
})

$('.js-page-next').click(function () {
    $('.pagination .active')
        .next()
        .trigger('click');
});
$('.js-page-prev').click(function () {
    $('.pagination .active')
        .prev()
        .trigger('click');
});

$('.js-filter-clear').click(function () {
    $('.js-filter').prop('checked', false);
    activeRegionFilters = []
    activeElementFilters = []
    activeConstraintFilters = []
    activeStyleFilters = []
    activeTypeFilters = []
    projects.items.forEach((item) => {
        item.regionmatch = true
        item.constraintmatch = true
        item.elementmatch = true
        item.stylematch = true
        item.typematch = true
    })
    projects.filter();
});

$('.js-open-filters').click(function () {
    let el = $(this);
    el.attr('aria-expanded', 'true');
    $('.js-close-filters').attr('aria-expanded', 'true');
    $('#filters').addClass('active');
    if (!navigator.userAgent.match(/(iPhone)/)) {
        disableBodyScroll('#filters');
    }
});

$('.js-close-filters').click(function () {
    let el = $(this);
    el.attr('aria-expanded', 'false');
    $('.js-open-filters').attr('aria-expanded', 'false');
    $('#filters').removeClass('active');
    enableBodyScroll('#filters');
});

$('.js-filter-list legend').click(function () {
    let el = $(this);
    el.toggleClass('active');
    if ( el.hasClass('active') ) {
        el.attr('aria-expanded', 'true');
    }   else {
        el.attr('aria-expanded', 'false');
    }
    el.next('.gallery__check-group').slideToggle();
});

$('.js-filter-list legend').keypress(function (e) {
    if (e.which == 13) {
        let el = $(this);
        el.toggleClass('active');
        if (el.hasClass('active')) {
            el.attr('aria-expanded', 'true');
        } else {
            el.attr('aria-expanded', 'false');
        }
        el.next('.gallery__check-group').slideToggle();
    }
});

let container = document.body;
let listener = SwipeListener(container);
container.addEventListener('swipe', function (e) {
    var directions = e.detail.directions;
    if (directions.left) {
        if ( $('#filters').hasClass('active') ) {
            $('.js-close-filters').attr('aria-expanded', 'false');
            $('.js-open-filters').attr('aria-expanded', 'false');
            $('#filters').removeClass('active');
            enableBodyScroll('#filters');
        }
    }
});
$('#filters').on('click', function (e) {
    if (e.target !== this)
        return;
    $('.js-close-filters').attr('aria-expanded', 'false');
    $('.js-open-filters').attr('aria-expanded', 'false');
    $('#filters').removeClass('active');
    enableBodyScroll('#filters');
});
$(window).on('resize', function (event) {
    if ($(window).width() > 700) {
        enableBodyScroll('#filters');
    }
})

$(document).ready(function () {
    if ($(window).width() < 700) {
        $("ul.list").slick(slickSettings);
    }

    let params = new URL(document.location).searchParams;
    if (params.has('region')) {
        let regions = params.get('region');
        let regionsArr = regions.split(',');
        regionsArr.forEach(function (currentValue) {
            $('#'+currentValue).prop('checked', true);
            let regionVal = $('#' + currentValue).val();
            activeRegionFilters.push(regionVal);
        });
        projects.items.forEach((item) => {
            if (activeRegionFilters.length > 0) {
                if (activeRegionFilters.indexOf(item.values().Region) > -1) {
                    item.regionmatch = true;
                } else {
                    item.regionmatch = false;
                }
            } else {
                item.regionmatch = true;
            }
        })
    }
    if (params.has('amenity')) {
        let elements = params.get('amenity');
        let elementsArr = elements.split(',');
        elementsArr.forEach(function (currentValue) {
            $('#' + currentValue).prop('checked', true);
            let elementVal = $('#' + currentValue).val();
            activeElementFilters.push(elementVal);
        });
        projects.items.forEach((item) => {
            if (activeElementFilters.length > 0) {
                let elements = item.values().Amenities
                let hasElement = false;
                elements.forEach(function (elements) {
                    if (activeElementFilters.indexOf(elements) > -1) {
                        hasElement = true;
                    }
                });
                if (hasElement == true) {
                    item.elementmatch = true;
                } else {
                    item.elementmatch = false;
                }
            } else {
                item.elementmatch = true;
            }
        })
    }
    if (params.has('yard-attribute')) {
        let constraints = params.get('yard-attribute');
        let constraintsArr = constraints.split(',');
        constraintsArr.forEach(function (currentValue) {
            $('#' + currentValue).prop('checked', true);
            let constraintVal = $('#' + currentValue).val();
            activeConstraintFilters.push(constraintVal);
        });
        projects.items.forEach((item) => {
            if (activeConstraintFilters.length > 0) {
                let constraints = item.values().YardAttributes
                let hasConstraint = false;
                constraints.forEach(function (constraints) {
                    if (activeConstraintFilters.indexOf(constraints) > -1) {
                        hasConstraint = true;
                    }
                });
                if (hasConstraint == true) {
                    item.constraintmatch = true;
                } else {
                    item.constraintmatch = false;
                }
            } else {
                item.constraintmatch = true;
            }
        })
    }
    if (params.has('style')) {
        let styles = params.get('style');
        let stylesArr = styles.split(',');
        stylesArr.forEach(function (currentValue) {
            $('#' + currentValue).prop('checked', true);
            let styleVal = $('#' + currentValue).val();
            activeStyleFilters.push(styleVal);
        });
        projects.items.forEach((item) => {
            if (activeStyleFilters.length > 0) {
                let styles = item.values().Styles
                let hasStyle = false;
                styles.forEach(function (styles) {
                    if (activeStyleFilters.indexOf(styles) > -1) {
                        hasStyle = true;
                    }
                });
                if (hasStyle == true) {
                    item.stylematch = true;
                } else {
                    item.stylematch = false;
                }
            } else {
                item.stylematch = true;
            }
        })
    }
    if (params.has('design-package')) {
        let packageTypes = params.get('design-package');
        let packageTypesArr = packageTypes.split(',');
        packageTypesArr.forEach(function (currentValue) {
            $('#' + currentValue).prop('checked', true);
            let packageTypeVal = $('#' + currentValue).val();
            activeTypeFilters.push(packageTypeVal);
        });
        projects.items.forEach((item) => {
            if (activeTypeFilters.length > 0) {
                if (activeTypeFilters.indexOf(item.values().DesignPackage) > -1) {
                    item.typematch = true;
                } else {
                    item.typematch = false;
                }
            } else {
                item.typematch = true;
            }
        })
    }
    if ( params.has('region') || params.has('amenity') || params.has('yard-attribute') || params.has('style') || params.has('design-package') ) {
        projects.filter(function (item) {
            if ((item.regionmatch == true) && (item.constraintmatch == true) && (item.elementmatch == true) && (item.stylematch == true) && (item.typematch == true)) {
                return true;
            } else {
                return false;
            }
        });
    }
});
